export enum LiceseType {
  FREE = 'FREE',
  TEAM = 'TEAM',
}

export type License =
  | {
      type: LiceseType.FREE;
      trialEndTime: string | null;
      createTime: string;
    }
  | { type: LiceseType.TEAM };
